import { Box, Skeleton } from '@mui/material';
import React from 'react';

export const TableSkeleton = () => {
  return (
    <Box mt={0.5} sx={{ border: '1px solid #e0e0e0', borderRadius: 1 }}>
      <Box sx={{ px: 1, py: 1, borderBottom: '1px solid #e0e0e0' }}>
        <Skeleton variant="rectangular" width="100%" height={45} />
      </Box>

      <Box sx={{ px: 1, pb: 1 }}>
        {Array.from({ length: 4 }, (_, index) => (
          <Skeleton key={index} variant="rectangular" width="100%" height={45} sx={{ mt: 1 }} />
        ))}
      </Box>
    </Box>
  );
};
